import React, { useContext, useState, useEffect } from "react";
import {
  Tab,
  Form,
  FormGroup,
  Input,
  TextArea,
  Grid,
  Label,
  Container,
  Button
} from "semantic-ui-react";
import WorkOrderStore from "../../../../app/stores/workorderStore";
import UserAuthStore from "../../../../app/stores/userauthStore"
import { observer } from "mobx-react-lite";
import { IWorkorder } from "../../../../app/models/workorder";
import WorkOrderSORSGrid from "../wo_sor_grid/WorkOrderSORSGrid";
import WorkOrderEngineerNotes from "../wo_engineer_notes/WorkOrderEngineerNotes";
import WorkOrderVarHistory from "../wo_varhistory/WorkOrderVarHistory";
import WorkOrderVariations from "../wo_variations/WorkOrderVariations";
import AppointmentGrid from "../wo_appointments/AppointmentGrid";
import AgedDebt from "../AgedDebt";
import axios from "axios";
import { worker } from "cluster";
import WorkOrderSORSGridOne from "../wo_sor_grid/WorkOrderSORSGridOne";
import WorkOrderEngineerNotesOne from "../wo_engineer_notes/WorkOrderEngineerNotesOne";
import { stat, statSync } from "fs";

//ADD230608 - check document tab (grid for variations, ageddebt)
import WorkOrderDocumentGrid from "../wo_document_grid/WorkOrderDocumentGrid_woad";
//ADD230614 - check clientnote tab
import WorkOrderClientnoteGrid from "../wo_clientnote_grid/WorkOrderClientnoteGrid_woad";

interface IProps {}

const AgedDebtDetails: React.FC<IProps> = () => {
  let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!) 
  

  const getPanes = (wo: IWorkorder) => {
    return [
      {
        menuItem: "Details",
        render: () => (
          <Tab.Pane attached={false}>
            <Container>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <Form widths="equal">
                      <FormGroup>
                        <Form.Field>
                          <Input
                            value={wo.JobNo}
                            label="Job No"
                            size="mini"
                            readonly
                            placeholder="Job No"
                            fluid
                          />
                        </Form.Field>
                        <Form.Field>
                          <Input
                            value={wo.ClientRef}
                            label="Client Ref"
                            size="mini"
                            readonly
                            placeholder="Client Ref"
                            fluid
                          />
                        </Form.Field>
                      </FormGroup>
  
  
                      <FormGroup>
                        <Form.Field>
                          <Input
                            label="Priority"
                            value={wo.Priority}
                            size="mini"
                            readonly
                            placeholder="Priority"
                            fluid
                          />
                        </Form.Field>
                        <Form.Field>
                          <Input
                            fluid
                            label="Value"
                            readonly
                            size="mini"
                            value={wo.JobValue}
                            placeholder="Value"
                          />
                        </Form.Field>
                      </FormGroup>
                      <FormGroup>
                        <Form.Field>
                          <Input
                            label="Invoice Number"
                            value={wo.InvoiceNumber}
                            size="mini"
                            readonly
                            placeholder="Priority"
                            fluid
                          />
                        </Form.Field>
                      </FormGroup>
                      <FormGroup>
                        <Form.Field>
                          <Input
                            label="Cause"
                            value={wo.Cause}
                            size="mini"
                            readonly
                            placeholder="Cause"
                            fluid
                          />
                        </Form.Field>
                       
                      </FormGroup>
                      
                      <FormGroup>
                        <Form.Field>
                          <Label>Site Address</Label>
                          <TextArea readonly value={wo.Address} />
                        </Form.Field>
                      </FormGroup>
                    </Form>
                  </Grid.Column>
                  <Grid.Column>
                    <Form widths="equal">
                      <FormGroup>
                        <Form.Field>
                          <Label>Job Summary</Label>
                          <TextArea readonly rows="10" value={wo.JobSummary} />
                        </Form.Field>
                      </FormGroup>
                    </Form>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </Tab.Pane>
        )
      },
      {
        menuItem: "Engineer Notes",
        render: () => (
          <Tab.Pane attached={false}>
            <WorkOrderEngineerNotes  />
          </Tab.Pane>
        )
        },
      {
        menuItem: "Debt",
      render: () => (
        <Tab.Pane attached={false}>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Form widths="equal">
                  <FormGroup>
                    <Form.Field>
                    <Label>Debt Comments</Label>                    
                    <TextArea readonly value={wo.AgedDebtComments} rows="10" />
                    </Form.Field>
                    <Grid.Column>              
                    </Grid.Column>
                  </FormGroup>
                </Form>
              </Grid.Column>
              <Grid.Column>
                <Form widths="equal">
                  <FormGroup>
                    <Form.Field>
                    <Label>Passed For Payment Time</Label>                    
                    <TextArea readonly value={wo.PassedForPaymentDate} rows="2" />
                    </Form.Field>
                  </FormGroup>
                </Form>
              </Grid.Column>
              <Grid.Column>
                <Form widths="equal">
                  <FormGroup>
                    <Form.Field>              
                    <form onSubmit={handleSubmit}>
                      <label>
                      <p><strong>Update Debt Comments</strong></p>
                        <input type="text" name="name" />
                        <button type="submit" value="Submit">Update</button>
                      </label>
                    </form>
                    </Form.Field>
                    <Form.Field>
                    <form >
                      <label>
                      
                      <p><strong>Update Query Status</strong></p>
                      <select onChange={(x) => onChangeOptionset(x)}>
                      <option value="870110000">queried</option>
                      <option value="870110002">credited</option>
                      <option selected value="100000000">not queried</option>
                    </select>
                    
                      </label>
                    </form>              
                                    
                    </Form.Field>

                  </FormGroup>
            
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Tab.Pane>
        )
      },
      ,
      {
        menuItem: "SORS",
        render: () => (
          <Tab.Pane attached={false}>
            <WorkOrderSORSGrid />
          </Tab.Pane>
        )
      },
    // {
    //   menuItem: "Engineer Notes",
    //   render: () => <Tab.Pane attached={false}>Engineer Notes</Tab.Pane>
    // },
    {
      menuItem: "Variation History",
      render: () => (
        <Tab.Pane attached={false}>
          <WorkOrderVarHistory />
        </Tab.Pane>
      )
    },
  
    {
      menuItem: "Appointments",
      render: () => (
        <Tab.Pane attached={false}>
          <AppointmentGrid/>
        </Tab.Pane>
      )
    },
  ];
  };

  const panes = [
    {
      menuItem: "Details",
      render: () => (
        <Tab.Pane attached={false}>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Form widths="equal">
                  <FormGroup>
                    <Form.Field>
                      <Input
                        label="Job No"
                        size="mini"
                        placeholder="Job No"
                        fluid
                      />
                    </Form.Field>
                    <Form.Field>
                      <Input
                        label="Client Ref"
                        size="mini"
                        placeholder="Client Ref"
                        fluid
                      />
                    </Form.Field>
                  </FormGroup>
  
                  <FormGroup>
                    {/* <Form.Field>
                      <Input
                        label="Status"
                        size="mini"
                        placeholder="Status"
                        fluid
                      />
                    </Form.Field> */}
                    <Form.Field>
                      <Input
                        label="Sub Status"
                        size="mini"
                        placeholder="Sub Status"
                        fluid
                      />
                    </Form.Field>
                  </FormGroup>
                  <FormGroup>
                    <Form.Field>
                      <Input
                        label="Priority"
                        size="mini"
                        placeholder="Priority"
                        fluid
                      />
                    </Form.Field>
                    <Form.Field>
                      <Input
                        fluid
                        label="Value"
                        size="mini"
                        placeholder="Value"
                      />
                    </Form.Field>
                  </FormGroup>
                  <FormGroup>
                    <Form.Field>
                      <Label>Site Address</Label>
                      <TextArea />
                    </Form.Field>
                  </FormGroup>
                </Form>
              </Grid.Column>
              <Grid.Column>
                <Form widths="equal">
                  <FormGroup>
                    <Form.Field>
                      <Label>Job Summary</Label>
                      <TextArea rows="10" />
                    </Form.Field>
                  </FormGroup>
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Tab.Pane>
      )
    },
    {
      menuItem: "Debt",
      render: () => (
        <Tab.Pane attached={false}>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Form widths="equal">
                  <FormGroup>
                    <Form.Field>
                    <Label>Debt Comments</Label>                    
                    <TextArea readonly rows="10" />
                    </Form.Field>
                  </FormGroup>
                </Form>
              </Grid.Column>
              
              <Grid.Column>
              <form onSubmit={handleSubmit}>
                <label>
                  <input type="text" name="name" />
                </label>
                <button type="submit" value="Submit" >Update</button>
              </form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Tab.Pane>
      )
    },
    {
      menuItem: "SORS",
      render: () => (
        <Tab.Pane attached={false}>
          <WorkOrderSORSGridOne />
        </Tab.Pane>
      )
    },
    // {
    //   menuItem: "Engineer Notes",
    //   render: () => <Tab.Pane attached={false}>Engineer Notes</Tab.Pane>
    // },
    {
      menuItem: "Variation History",
      render: () => <Tab.Pane attached={false}>Variation History</Tab.Pane>
    },
  
    {
      menuItem: "Appointments",
      render: () => <Tab.Pane attached={false}>Appointments</Tab.Pane>
    },
  ];

//ADD 251030 for peabody document tab
const getPeabodyPanes = (wo: IWorkorder) => {
  var PeabodyPanes = getPanes(wo)
  PeabodyPanes.push({
    menuItem: "Documents",
    render: () => (
       <Tab.Pane attached={false}><WorkOrderDocumentGrid  /></Tab.Pane>
    )
    });
    
  return PeabodyPanes;
  };


//ADD 230608 for origin document tab
const getOriginPanes = (wo: IWorkorder) => {
  var OriginPanes = getPanes(wo)
  OriginPanes.push({
    menuItem: "Documents",
    render: () => (
       <Tab.Pane attached={false}><WorkOrderDocumentGrid  /></Tab.Pane>
     )
     });
  OriginPanes.push({
    menuItem: "Notes",
    render: () => (
        <Tab.Pane attached={false}><WorkOrderClientnoteGrid  /></Tab.Pane>
     )
     });           
  return OriginPanes;
  };

  
  const [status,setStatus] = useState('');


  function onChangeOptionset(e){
    setStatus(e.target.value);
    AgedDebtQueryUpdate(e.target.value,workorder.JobId)
  }

//   function onChange(event) {

//     setStatus(event.target.value);
//   }
// function submitquery(){
//   AgedDebtQueryUpdate(workorder.JobId)

// }
  

  useEffect(() => {
    console.log(status)
   }, [status]);

  function AgedDebtCommentUpdate(message,WorkOrderid){
      var url = "https://gilm-clientportal-test.azurewebsites.net/CP/debt/SetAgedDebtComment"
      console.log(message)
      var body = {
        comment: message,
        workorderId : WorkOrderid
      }
      axios.post(url,body)
      .then(x => {
        SetAgedDebtResponse(x.data)
        alert(x.data);
      })
  }
  
  function AgedDebtQueryUpdate(status,WorkOrderid){

    var url = "https://gilm-clientportal-test.azurewebsites.net/CP/debt/setAgedDebtQueried"
    console.log(status)
    var body = {
      optionset: status,
      workorderId : WorkOrderid
    }
    axios.post(url,body)
    .then(x => {
      SetAgedDebtResponse(x.data)
      alert(x.data);
    })
}

  const userauthStore = useContext(UserAuthStore);
  const workorderStore = useContext(WorkOrderStore);

  const { selectedWorkOrder: workorder } = workorderStore;
  const [tabContent, setTabContent] = useState([{}]);
  const [agedDebtResponse, SetAgedDebtResponse] = useState("");


  const handleSubmit = (e) =>
  {  
      e.preventDefault();
      var message = e.target[0].value
      console.log("MESSAGE - " + message)
      AgedDebtCommentUpdate(message,workorder.JobId)
  }

  useEffect(() => {
    userauthStore.HydrateAuthState();
   }, [userauthStore]);
 

  useEffect(() => {
    var cli = sessionObj.Client.Name;
    console.log('client',cli )
    if (workorder != null) {
      console.log("workorder not null")
      //CHANGE 230608 for origin document tab
      if(cli == "Origin Housing" || cli == "Origin"){
        setTabContent(getOriginPanes(workorder));
      } else if(cli == "Peabody New Contract 2024" || cli == "Peabody"){
        //ADD 251030 for peabody document tab
        setTabContent(getPeabodyPanes(workorder))
      } else{
        setTabContent(getPanes(workorder));
      }

    } else {
      console.log("workorder is null")
      setTabContent(panes);
    }
  }, [workorder]);

  return (
    <div>
      <Tab
        menu={{ fluid: true, vertical: true, tabular: false }}
        panes={tabContent}
      />
    </div>
  );
};

export default observer(AgedDebtDetails);
